export default __webpack_public_path__ + "454fab9821e134efc27a3e297341bb6a.png";